export default __webpack_public_path__ + "static/media/accounts1.4908d79b.svg";